// Stylized baseball diamond with clickable fielder spots.
const SPOTS = [
  { id: "Pitcher", label: "P", x: 150, y: 168 },
  { id: "Catcher", label: "C", x: 150, y: 252 },
  { id: "1B", label: "1B", x: 222, y: 150 },
  { id: "2B", label: "2B", x: 196, y: 112 },
  { id: "SS", label: "SS", x: 104, y: 112 },
  { id: "3B", label: "3B", x: 78, y: 150 },
  { id: "LF", label: "LF", x: 62, y: 58 },
  { id: "CF", label: "CF", x: 150, y: 30 },
  { id: "RF", label: "RF", x: 238, y: 58 },
];

export const DiamondField = ({ value, onSelect }) => (
  <svg viewBox="0 0 300 285" className="w-full max-w-[320px] mx-auto select-none" data-testid="onb-diamond-field">
    <path d="M 8 205 A 160 160 0 0 1 292 205 L 150 235 Z" fill="#E6FBFD" stroke="#A5F3FC" strokeWidth="1.5" />
    <polygon points="150,100 215,165 150,230 85,165" fill="#F1F5F9" stroke="#CBD5E1" strokeWidth="1.5" />
    <polygon points="150,112 203,165 150,218 97,165" fill="none" stroke="#E2E8F0" strokeWidth="1" strokeDasharray="3 3" />
    <circle cx="150" cy="165" r="9" fill="#E2E8F0" />
    {[[150, 100], [215, 165], [85, 165]].map(([x, y]) => (
      <rect key={`${x}${y}`} x={x - 5} y={y - 5} width="10" height="10" fill="#fff" stroke="#94A3B8" strokeWidth="1.5" transform={`rotate(45 ${x} ${y})`} />
    ))}
    <polygon points="144,226 156,226 156,232 150,238 144,232" fill="#fff" stroke="#94A3B8" strokeWidth="1.5" />
    {SPOTS.map((s) => {
      const active = value === s.id;
      return (
        <g key={s.id} data-testid={`onb-position-${s.id}`} role="button" tabIndex={0} onClick={() => onSelect(s.id)}
           onKeyDown={(e) => e.key === "Enter" && onSelect(s.id)} className="cursor-pointer" style={{ transition: "transform .15s" }}>
          <circle cx={s.x} cy={s.y} r="18" fill={active ? "#2563EB" : "#fff"} stroke={active ? "#2563EB" : "#CBD5E1"} strokeWidth="1.5"
                  className="transition-colors hover:stroke-royal" style={{ filter: "drop-shadow(0 2px 4px rgba(10,25,47,.12))" }} />
          <text x={s.x} y={s.y + 4.5} textAnchor="middle" fontSize="12" fontWeight="800" fontFamily="Manrope, sans-serif"
                fill={active ? "#fff" : "#0A192F"} style={{ pointerEvents: "none" }}>{s.label}</text>
        </g>
      );
    })}
  </svg>
);

export default DiamondField;
